






















































































import Swiper from 'swiper';
import Button from 'frontend/components/Button.vue';
import { LearningPathLevel, LearningPathV2 } from 'frontend/types/learningPathV2';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from './Header.vue';
import ProgressBar from './ProgressBar.vue';
import Tag from './Tag.vue';
import { track } from 'frontend/utils/analytics';
import CoursesModal from './CoursesModal.vue';
import BadgeLabel from 'frontend/views/learningPathV2/BadgeLabel.vue';

@Component({
  components: {
    BadgeLabel,
    Button,
    CoursesModal,
    Header,
    ProgressBar,
    Tag,
  },
})
export default class Desktop extends Vue {
  @Prop({ type: Object, required: true })
  private learningPath!: LearningPathV2;
  private isReady: boolean = false;
  private isModalOpen: boolean = false;
  private activeIndex: number = this.learningPath.current_level_number - 1;
  private previousIndex: number = this.activeIndex;
  private $swiper?: Swiper = undefined;

  mounted(): void {
    this.isReady = true;
  }

  private badgeColor(level: LearningPathLevel): string {
    if (this.isComplete(level) || this.isPlacedOut(level)) {
      return '#179E7E';
    }
    return this.learningPath.color_scheme.s_500;
  }

  private get ctaCopy(): string {
    if (this.isComplete(this.selectedLevel) || this.isPlacedOut(this.selectedLevel)) {
      return 'View level';
    }
    if (this.isStarted(this.selectedLevel)) {
      return 'Continue';
    }
    return `Start level ${this.selectedLevel.number}`;
  }

  private get selectedLevel(): LearningPathLevel {
    return this.learningPath.levels[this.activeIndex];
  }

  private isComplete(level: LearningPathLevel): boolean {
    return level.percent_complete === 100;
  }

  private isStarted(level: LearningPathLevel): boolean {
    return !this.isComplete(level) && level.percent_complete > 0;
  }

  private isPlacedOut(level: LearningPathLevel): boolean {
    return (
      !this.isStarted(level) &&
      level.number < this.learningPath.current_level_number &&
      this.learningPath.nux_placement_level_number !== null &&
      level.number < this.learningPath.nux_placement_level_number
    );
  }

  private isCurrentLevel(level: LearningPathLevel): boolean {
    return level.number === this.learningPath.current_level_number;
  }

  private updateIndexAndSlide(index: number): void {
    this.activeIndex = index;
    this.$swiper?.slideTo(index);
  }

  private renderCarousel(): void {
    this.isReady = true;
  }

  private updateActiveIndex(): void {
    this.previousIndex = this.activeIndex;
    this.activeIndex = this.$swiper!.activeIndex;
  }

  private openModal(level: LearningPathLevel): void {
    track('ui', {
      action: 'click',
      element_id: 'clicked_level',
      current_level: this.learningPath.current_level_number,
      clicked_level: level.number,
      learning_path_id: this.learningPath.id,
      learning_path_slug: this.learningPath.slug,
    });

    this.isModalOpen = true;
  }

  /**
   * To emulate the event lifecycle behavior of swiper's click event, we need to
   * track previousIndex ourselves because this click event will fire after
   * updateActiveIndex + nextTick.
   */
  private openModalOrUpdatePreviousIndex(level: LearningPathLevel, clickedCardIndex: number): void {
    if (clickedCardIndex !== this.activeIndex) {
      // handles drag-clicks that don't result in a card being moved into the active position
      return;
    }

    if (this.previousIndex === this.activeIndex) {
      this.openModal(level);
    }

    this.previousIndex = this.activeIndex;
  }
}
